import { IntlShape } from "react-intl";

export function getRequiredMessage(intl: IntlShape) {
  return intl.formatMessage({
    id: "request-form.service.requirements.validation.required",
    defaultMessage: "This is required",
  });
}

export function getValidTimeMessage(intl: IntlShape) {
  return intl.formatMessage({
    id: "general.validTimeError",
    defaultMessage: "Enter a valid time",
  });
}

export function getSelectableDateMessage(intl: IntlShape) {
  return intl.formatMessage({
    id: "validation.selectableDate",
    defaultMessage: "Selected date is in the past, please select a date in the future",
  });
}

export function isEmptyValue(value: unknown): boolean {
  if (value === null || value === undefined || value === "") return true;
  if (typeof value === "string" && !value.trim()) return true;
  return false;
}

export function getTimeDigitCount(value: unknown): number {
  if (isEmptyValue(value)) return 0;
  return String(value).replace(/\D/g, "").length;
}

export function hasCompleteTimeInput(value: unknown): boolean {
  return getTimeDigitCount(value) >= 4;
}

export function isValidTimeValue(value: unknown): boolean {
  if (!hasCompleteTimeInput(value)) return false;
  const str = String(value);
  const digits = str.replace(/\D/g, "");
  const h = parseInt(digits.slice(0, 2), 10);
  const m = parseInt(digits.slice(2, 4), 10);
  return h <= 23 && m <= 59;
}
